// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA9b3jCvZry-coIEPM2qcD0TofcA2OOoWE",
  authDomain: "hemant-website-99d77.firebaseapp.com",
  projectId: "hemant-website-99d77",
  storageBucket: "hemant-website-99d77.firebasestorage.app",
  messagingSenderId: "1013716957460",
  appId: "1:1013716957460:web:6f3d209008d62f22846a01",
  measurementId: "G-MP633GT3JR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and export it for use in other parts of the app
export const auth = getAuth(app);
